import { ComboBoxModel } from "@genexus/chameleon-controls-library";
import { GxOption } from "../..";

export const mapOptionsToComboBoxItemModel = (
  options: GxOption[]
): ComboBoxModel => {
  return options.map(option => {
    return {
      value: option.id,
      caption: option.label,
      startImgSrc: option.iconName ?? ""
    };
  });
};
